import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentDto, ShipmentHeader, ShipmentHeaderDto } from './models/shipment.dto';

@Injectable({ providedIn: 'root' })
export class ShipmentProvider {
  constructor(private http: HttpClient) {}

  getShipment(shipmentId: number): Observable<ShipmentDto> {
    const url = `/api/shipments/${shipmentId}`;
    return this.http.get<ShipmentDto>(url);
  }

  createShipment(header: ShipmentHeader): Observable<ShipmentHeaderDto> {
    const url = `/api/shipments`;
    return this.http.post<ShipmentHeaderDto>(url, header);
  }

  patchShipment(shipmentId: number, header: ShipmentHeader): Observable<void> {
    const url = `/api/shipments/${shipmentId}`;
    return this.http.patch<void>(url, header);
  }

  patchShipmentItemAmount(shipmentId: number, shipmentItemId: number, amount: number): Observable<void> {
    const url = `/api/shipments/${shipmentId}/items/${shipmentItemId}/amount`;
    return this.http.patch<void>(url, { amount });
  }

  // takes the position off the shipment; its amount is free to ship again
  deleteShipmentItem(shipmentId: number, shipmentItemId: number): Observable<void> {
    const url = `/api/shipments/${shipmentId}/items/${shipmentItemId}`;
    return this.http.delete<void>(url);
  }

  shipShipment(shipmentId: number): Observable<void> {
    const url = `/api/shipments/${shipmentId}/ship`;
    return this.http.patch<void>(url, {});
  }

  // the correction at the ramp: back to Planowana, the lines untouched
  unshipShipment(shipmentId: number): Observable<void> {
    const url = `/api/shipments/${shipmentId}/unship`;
    return this.http.patch<void>(url, {});
  }
}
